import { Client } from 'urql'
import { Mutation_Root } from 'src/@types/graphql'
import { deleteCriteriaGroupConfigById } from 'src/screens/administration/configuration-management/criteria-configuration/criteriaConfigQueries'

export const deleteCriteriaGroup = (urqlClient: Client) => async (groupId: number) => {
  const { data, error } = await urqlClient
    .mutation<{ delete_criteria_group_config: Mutation_Root['delete_criteria_group_config'] }, { groupId: number }>(
      deleteCriteriaGroupConfigById,
      {
        groupId,
      },
    )
    .toPromise()

  if (error || data?.delete_criteria_group_config?.affected_rows !== 1) {
    throw new Error('Criteria group deletion error')
  }

  return true
}
